// @vendor
const moment = require('moment');
const get = require('lodash/object/get');
const isNull = require('lodash/lang/isNull');

// @core
const apiURLBuilder = require('core/apiURLBuilder');

// @utilities
const { APIGet } = require('utilities/APIRequestHelper');
const { countActiveFilters } = require('utilities/filtersHelper');

// @constants
const actionTypes = require('constants/actionTypes');
const CURRENT_DATE = moment().startOf('day');
const DATE_FILTER_MIN_DATE_LIMIT = moment().startOf('day').subtract(2, 'years');
const { DATE_FORMAT_API, DATE_FILTER_CUSTOM } = require('constants/index');
const { TYPES } = require('constants/movementsTypes');
const { PFM_NEW_FEATURES } = require('constants/flagBasedFeatures');
const { EURO_TEXT } = require("constants/index");


const accountTransactionsOutdated = () => {
    return {
        type: actionTypes.ACCOUNT_TRANSACTIONS_OUTDATED
    };
};

const requestAccountTransactionsInProgress = accountId => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_REQUEST,
    payload: {
        accountId
    }
});

const requestAccountInfoSuccess = (data, accountId, hasNewPFMFeaturesFF) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        movements: get(data, hasNewPFMFeaturesFF ? 'methodResult.movimientos' : 'movimientos', []) || [],
        repagination: get(data, hasNewPFMFeaturesFF ? 'methodResult.repaginacion' : 'repaginacion', []) || [],
        self: get(data, '_links.self.href', ''),
        scaRequired: !__CONTACT_CENTER__ ? get(data, hasNewPFMFeaturesFF ? 'methodResult.scaRequired' : 'scaRequired', false) : false,
    }
});

const requestAccountInfoFailure = (data, accountId) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_FAILURE,
    payload: {
        accountId,
        data
    }
});

const requestNextAccountTransactionsPageRequest = accountId => ({
    type: actionTypes.FETCH_NEXT_ACCOUNT_TRANSACTIONS_PAGE_REQUEST,
    payload: {
        accountId
    }
});

const requestNextAccountTransactionsPageSuccess = (data, accountId, hasNewPFMFeaturesFF) => ({
    type: actionTypes.FETCH_NEXT_ACCOUNT_TRANSACTIONS_PAGE_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        moreMovements: get(data, 'masMovimientos', false) || false,
        movements: get(data, hasNewPFMFeaturesFF ? 'methodResult.movimientos' : 'movimientos', []) || [],
        repagination: get(data, hasNewPFMFeaturesFF ? 'methodResult.repaginacion' : 'repaginacion', []) || [],
        self: get(data, '_links.self.href', ''),
        scaRequired: !__CONTACT_CENTER__ ? get(data, hasNewPFMFeaturesFF ? 'methodResult.scaRequired' : 'scaRequired', false) : false,
    }
});

const fetchAccountTransactionsFilter = filters => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_FILTER, // tagged for analytics
    payload: {
        filters
    }
});

const checkAccountTransactionsFilter = () => (dispatch, getState) => {
    const immFilter = getState().accountsTransactions.get('filters');

    if (countActiveFilters(immFilter) === 0) {
        dispatch(accountTransactionsOutdated());
    }
};

const fetchResetAccountTransactionsFilter = filterKey => ({
    type: actionTypes.RESET_ACCOUNT_TRANSACTIONS_FILTER,
    payload: {
        filterKey
    }
});

const requestClearAccountTransactionsFilter = () => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_FILTER_CLEAR // tagged for analytics
});

const clearAccountTransactionsFilter = () => (dispatch, getState) => {
    const immFilter = getState().accountsTransactions.get('filters');

    if (countActiveFilters(immFilter) > 0) {
        dispatch(requestClearAccountTransactionsFilter());
        dispatch(accountTransactionsOutdated());
    }
}

const setAccountTransactionsFilter = filters => dispatch => {
    dispatch(fetchAccountTransactionsFilter(filters));
    dispatch(checkAccountTransactionsFilter());
};

const resetAccountTransactionFilter = filter => (dispatch, getState) => {
    const immFilter = getState().accountsTransactions.get('filters');

    if (countActiveFilters(immFilter) === 1) {
        dispatch(clearAccountTransactionsFilter());
    }
    dispatch(fetchResetAccountTransactionsFilter(filter));
};

const updateAccountTransactionCategory = (accountId, transactionId, category, subcategory) => ({
    type: actionTypes.ACCOUNT_TRANSACTIONS_CHANGE_CATEGORY,
    payload: {
        accountId,
        transactionId,
        category,
        subcategory
    }
});

const requestAccountTransactions = accountId => (dispatch, getState) => {
    const immAccountTransactions = getState().accountsTransactions.get(accountId);
    const immFilter = getState().accountsTransactions.get('filters');
    const filterActive = countActiveFilters(immFilter) > 0;
    if (
        filterActive ||
        !immAccountTransactions ||
        immAccountTransactions.get('isOutdated') ||
        !!immAccountTransactions.get('error')
    ) {
        const immAccount =
            getState().accounts.get('byId').get(accountId) ||
            getState().accounts.getIn(['futureAccountsById', accountId]);
        const filterDateFrom = immFilter.getIn(['date', 'from']) || DATE_FILTER_MIN_DATE_LIMIT;
        const hasNewPFMFeaturesFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(PFM_NEW_FEATURES) : false;
        const accountsRequestData = {
            query: {},
            header: hasNewPFMFeaturesFF ? {
                version: 3
            } : {}
        };


        let filterDateTo, amountFrom, amountTo, movementType, concept,textFilter,immTextFilter;

        if (immFilter.getIn(['date', 'selected']) === DATE_FILTER_CUSTOM) {
            filterDateTo = immFilter.getIn(['date', 'to']) || CURRENT_DATE;
        }

        accountsRequestData.query = {
            fechaDesde: filterDateFrom && filterDateFrom.format(DATE_FORMAT_API),
            fechaHasta: filterDateTo && filterDateTo.format(DATE_FORMAT_API),
            numeroContrato: immAccount.get('contractNumber'),
            producto: immAccount.get('product')
        };

        textFilter=immFilter.getIn(['description', 'selected']);
        immTextFilter=immFilter.getIn(['description', 'isActive']);
        if (!isNull(textFilter) && immTextFilter){
            accountsRequestData.query.descripcion = textFilter;
        }
        
        amountFrom = immFilter.get('amount').get('from').get('amount');
        if (!isNull(amountFrom)){
            accountsRequestData.query.divisaImporteDesde =immFilter.get('amount').get('from').get('currency') || EURO_TEXT;
            accountsRequestData.query.importeDesde = amountFrom;
        }

        amountTo = immFilter.get('amount').get('to').get('amount');
        if (!isNull(amountTo)){
            accountsRequestData.query.divisaImporteHasta =  immFilter.get('amount').get('to').get('currency') || EURO_TEXT ;
            accountsRequestData.query.importeHasta = amountTo;
        }

        movementType = immFilter.getIn(['movementType', 'movementType']);
        if (!isNull(movementType) && movementType !== TYPES.ALL) {
            accountsRequestData.query.tipoMovimiento = movementType;
        }

        concept = immFilter.getIn(['concept', 'concept']);
        if (!isNull(concept) && concept !== TYPES.ALL) {
            accountsRequestData.query.concepto = concept;
        }

        dispatch(requestAccountTransactionsInProgress(accountId));
        return APIGet({
            dispatch,
            endpoint: 'accountTransactions',
            url: apiURLBuilder.getURL('accountTransactions'),
            params: accountsRequestData
        })
        .then(response => dispatch(requestAccountInfoSuccess(response, accountId, hasNewPFMFeaturesFF)))
        .catch(response => dispatch(requestAccountInfoFailure(response.error, accountId)))
    }
}

const toggleAccountMovementsScaModal = (accountId) => ({
    type: actionTypes.SET_ACCOUNT_SCA_MODAL_SHOW,
    payload: {
        accountId
    }
})

const requestNextAccountTransactionsPage = (accountId, forceSelf = false) => (dispatch, getState) => {
    let nextPageURL;
    if (forceSelf) {
        nextPageURL = getState().accountsTransactions.get(accountId).get('selfPage');
    } else {
        nextPageURL = getState().accountsTransactions.get(accountId).get('nextPage');
    }
    const hasNewPFMFeaturesFF = getState().flagBasedFeatures ?  getState().flagBasedFeatures.get(PFM_NEW_FEATURES) : false;
    dispatch(requestNextAccountTransactionsPageRequest(accountId));
    const accountEndpointVersion = {
        header: hasNewPFMFeaturesFF ? { version: 3 } : {}
    };
    return APIGet(dispatch, nextPageURL, accountEndpointVersion)
        .then(response => dispatch(requestNextAccountTransactionsPageSuccess(response, accountId, hasNewPFMFeaturesFF)))
        .catch(response => dispatch(requestAccountInfoFailure(response.error, accountId)));
};

module.exports = {
  accountTransactionsOutdated,
  clearAccountTransactionsFilter,
  requestAccountTransactions,
  requestNextAccountTransactionsPage,
  resetAccountTransactionFilter,
  setAccountTransactionsFilter,
  toggleAccountMovementsScaModal,
  updateAccountTransactionCategory,
}